import axios from 'axios'
const server = process.env.VUE_APP_API_URL || ''
const api = `${server}/api/customer/marketing`

const checkImageUseAgreement = () => {
  return axios.get(api + '/imageuseagreement/')
}
const saveImageUseAgreement = (agreement) => {
  return axios.post(api + '/imageuseagreement/', agreement)
}

export default {
  checkImageUseAgreement,
  saveImageUseAgreement
}
